<script>
    import i18n from '../common/plugins/vue-i18n'
    const appSidebarMenu = [
        {
            text: i18n.t('GENERAL.Navigation'),
            is_header: true
        },
        {
            url: '/Home',
            icon: 'fa fa-laptop',
            text: i18n.t('GENERAL.Home')
        },
        // {
        //     url: '/Case',
        //     icon: 'fa fa-list',
        //     text: 'Case'
        // },
        // {
        //     url: '/User',
        //     icon: 'fa fa-user',
        //     text: 'User'
        // },
        // {
        //     url: '/Email',
        //     icon: 'fa fa-list-ol',
        //     text: 'Email'
        // },
        // {
        //     url: '/Todo',
        //     icon: 'far fa-check-circle',
        //     text: 'Todo'
        // }
    ];
    export default appSidebarMenu;
</script>
